import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from '../../theme';
import useBadgeButtonStyles from './BadgeButton.Styles';
const BadgeButton = React.forwardRef(({ fullWidth, className, sx, children, ...props }, ref) => {
    const theme = useTheme();
    const styles = useBadgeButtonStyles({
        ...{ fullWidth, ...props },
        theme
    });
    return (_jsx("button", { ref: ref, className: `${styles.common} ${className || ''}`, ...props, style: sx, children: children }));
});
BadgeButton.displayName = 'BadgeButton';
export default BadgeButton;
